export default "__VITE_ASSET__BuqdSqxh__"